import { ListMessageSetTitles, ListMessageSetTitlesVariables } from './__generated__/ListMessageSetTitles'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListMessageSetTitles($input: ListMessageSetInputV2!) {
    listMessageSetsV2(input: $input) {
      messageSets {
        id
        title
      }
    }
  }
`

export const useListMessageSetTitles = (variables: ListMessageSetTitlesVariables) => {
  return useQuery<ListMessageSetTitles, ListMessageSetTitlesVariables>(QUERY, {
    variables
  })
}
